import React, { useState } from 'react';
import { track } from '../utils/analytics';

// Single source of truth for the booking URL. If this changes, only
// this constant and the matching references in marketing/index.html
// need to move together.
export const BOOKING_URL = 'https://cal.com/glenn-hogg-xyidfl';

export default function ConsultantModal({ open, onClose }) {
  const [showCal, setShowCal] = useState(false);

  if (!open) return null;

  const handleClose = () => {
    setShowCal(false);
    onClose();
  };

  const handleBookClick = () => {
    track('book_call_clicked', { source: 'consultant_modal' });
    setShowCal(true);
  };

  return (
    <div className="consultant-overlay" onClick={handleClose}>
      <div
        className={'consultant-modal' + (showCal ? ' consultant-modal--wide' : '')}
        onClick={e => e.stopPropagation()}
      >
        <button className="consultant-close" onClick={handleClose}>✕</button>

        {!showCal ? (
          <>
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1.25rem' }}>
              <div className="consultant-avatar">GH</div>
              <div>
                <div style={{ fontSize: '1.05rem', fontWeight: 700, color: '#1a1a2e' }}>Glenn Hogg</div>
                <div style={{ fontSize: '0.8rem', color: '#888' }}>InPragmia Consulting</div>
              </div>
            </div>

            <div className="consultant-tagline">Strategy · Organisation design · Facilitation</div>

            <p style={{ fontSize: '0.85rem', color: '#333', lineHeight: 1.65, margin: '0 0 1.25rem' }}>
              Glenn brings 20 years of engineering rigour and organisational expertise — from Rolls-Royce operations to senior consulting across utilities, regulated industries and high-growth SMEs. He specialises in helping leadership teams turn strategic clarity into action: structured option development, operating model design, and decisions that stick.
            </p>

            <button
              type="button"
              onClick={handleBookClick}
              style={{
                display: 'block',
                width: '100%',
                background: '#1D9E75',
                color: 'white',
                textAlign: 'center',
                padding: '0.8rem 1rem',
                borderRadius: 8,
                fontWeight: 600,
                fontSize: '0.9rem',
                border: 'none',
                cursor: 'pointer',
                marginBottom: '1.25rem',
                transition: 'opacity 0.15s',
                fontFamily: 'inherit',
              }}
              onMouseEnter={e => { e.currentTarget.style.opacity = 0.88; }}
              onMouseLeave={e => { e.currentTarget.style.opacity = 1; }}
            >
              Book a 15min call →
            </button>

            <div className="consultant-divider" />

            <div className="consultant-contact-row">
              <div className="consultant-contact-icon">✉</div>
              <a href="mailto:glennhogg01@gmail.com">glennhogg01@gmail.com</a>
            </div>
            <div className="consultant-contact-row">
              <div className="consultant-contact-icon">📞</div>
              <a href="tel:07775028953">0777 502 8953</a>
            </div>
            <div className="consultant-contact-row">
              <div className="consultant-contact-icon">in</div>
              <a href="https://linkedin.com/in/glenn-hogg" target="_blank" rel="noreferrer">linkedin.com/in/glenn-hogg</a>
            </div>

            <div className="consultant-divider" />

            <p className="consultant-note">
              GuruOne is built on InPragmia's consulting practice. Glenn can help you work through your challenge in person — and where a different specialism is needed, he'll connect you with the right consultant from his network.
            </p>
          </>
        ) : (
          <div className="consultant-cal-wrap">
            <button
              type="button"
              onClick={() => setShowCal(false)}
              style={{
                background: 'none',
                border: 'none',
                color: '#1D9E75',
                fontSize: '0.85rem',
                fontWeight: 500,
                cursor: 'pointer',
                padding: '0 0 0.6rem',
                fontFamily: 'inherit',
                width: 'auto',
              }}
            >
              ← Back
            </button>
            <iframe
              src={BOOKING_URL}
              title="Book a 15 minute call with Glenn"
              className="consultant-cal-frame"
              loading="lazy"
            />
          </div>
        )}
      </div>
    </div>
  );
}
